import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { UserDetails } from '@/hooks/queries/use-get-user-detail.query';

type UserDetailState = {
  userDetails: UserDetails | null;
  setUser: (user: UserDetails | null) => void;
  clearUser: () => void;
};

export const useUserDetailStore = create<UserDetailState>()(
  devtools(
    set => ({
      userDetails: null,
      setUser: userDetails => set({ userDetails }),
      clearUser: () => set({ userDetails: null }),
    }),
    {
      name: 'UserDetailStore',
      anonymousActionType: 'userDetailSetter',
    }
  )
);
